import type {
  StepUpTransformersQueryVariables,
  Step_Up_Transformers_Bool_Exp
} from "gql/api";
import { Order_By } from "gql/api";

export function restoreStepUpTransformers(
  arr: Array<string>
): Step_Up_Transformers_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteStepUpTransformers(
  arr: Array<string>
): Step_Up_Transformers_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultUpTransVars: StepUpTransformersQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ]
};

export const adminUpTransVars: StepUpTransformersQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ]
};

export const kocUpTransVars: StepUpTransformersQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};
export const ecopetrolUpTransVars: StepUpTransformersQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
